import React from 'react';
import { useDispatch } from 'react-redux';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
// import { validatePolicy } from '../../tools';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useSalesChannelIsMiniProgram } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import TipsAndSwitch from 'src/constrains/SalesChannelPreviewPageComponents/TipsAndSwitch';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getManagement,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onManagementChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/slice';
import { i18nGet } from 'src/tools/tools';
import { EnumCollapseId } from '../../common';
import css from './css.module.less';
const Management = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //   const params: any = useParams();
  //   const { contentUuid } = params;
  const isMiniProgram = useSalesChannelIsMiniProgram();

  const {
    data,
    // display: _display,
    // specificError,
    // linkSet,
    //isPrimary,
  } = props;
  const { subscriptionBuy, voucher, thirdPartyLogin, myAddress } = data || {};

  const _d = useDispatch();

  const handleOnSubscriptionBuyChange = (subscriptionBuy) => {
    _d(onManagementChange({ subscriptionBuy }));
  };

  const handleVoucherChange = (voucher) => {
    _d(onManagementChange({ voucher }));
  };

  const handleMyAddressChange = (myAddress) => {
    _d(onManagementChange({ myAddress }));
  };
  const handleThirdPartyChange = (thirdPartyLogin) => {
    _d(onManagementChange({ thirdPartyLogin }));
  };

  return (
    <Section className={css.container} bottomBorder>
      <div className={css.title}>
        {getI18n('salesChannelContent.index.displaythefollowing')}
      </div>
      {!isMiniProgram && (
        <div className={css.itemContainer}>
          <TipsAndSwitch
            enabled={subscriptionBuy}
            onChange={handleOnSubscriptionBuyChange}
            title={getI18n('general.subscriptionBuy')}
          />
        </div>
      )}

      <div className={css.itemContainer}>
        <TipsAndSwitch
          enabled={voucher}
          onChange={handleVoucherChange}
          title={getI18n('general.sider.voucher')}
        />
      </div>
      <div className={css.itemContainer}>
        <TipsAndSwitch
          enabled={myAddress}
          onChange={handleMyAddressChange}
          title={getI18n('salesChannelContent.index.myAddress')}
        />
      </div>
      {!isMiniProgram && (
        <div className={css.itemContainer}>
          <TipsAndSwitch
            enabled={thirdPartyLogin}
            onChange={handleThirdPartyChange}
            title={getI18n('salesChannelContent.index.thirdPartyLogin')}
          />
        </div>
      )}
    </Section>
  );
};

export default ErrorProcessingHOC(Management, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.management,
  getContent: getManagement,
  title: getI18nFromGeneral('general.hOCTitle.profileContentManagement'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,

  //   validation: (x, _p) => {
  //     const { isPrimary } = _p;
  //     return validatePolicy(x, isPrimary);
  //   },
  getSubmitStamp: getSubmitStamp,
});
